"use client";

import DestinationCard from "@/components/card/DestinationCard";
import HomeCarouselSection from "../../HomeCarouselSection";
import BannerSkeleton from "@/components/skeletons/card/BannerSkeleton";
import { useTopDestination } from "@/hooks/top-destination/useTopDestination";

const TopDestinations = () => {
  const { data: topDestinations, isLoading } = useTopDestination({
    svcType: "all",
    limit: 10,
  });

  return (
    <HomeCarouselSection<any>
      title="Top Destinations / គោលដៅពេញនិយមបំផុត"
      href=""
      items={topDestinations?.data}
      isFetching={isLoading}
      itemsPerCol={3}
      getKey={(destination) => destination.id}
      renderItem={(destination) => (
        <DestinationCard
          destination={destination}
          href={`/global-search?locationId=${destination.id}&source=destination`}
        />
      )}
      renderSkeleton={() => <BannerSkeleton />}
    />
  );
};

export default TopDestinations;